import type { AuthProvidersDto } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";

import { AUTH_PROVIDERS_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";

// export const getAuthProviders = async () => {

//   const response = await axios.get<AuthProvidersDto>(`/auth/providers`);

//   return response.data;

// };
export const getAuthProviders = async () => {
  try {
    const response = await axios.get<AuthProvidersDto>(`/auth/providers`);
    return response.data; // Ensure a non-undefined return
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to fetch auth providers:", error);
    return []; // Return an empty array if the request fails
  }
};

export const useAuthProviders = () => {
  const {
    error,
    isPending: loading,
    data: providers,
  } = useQuery({
    queryKey: [AUTH_PROVIDERS_KEY],
    queryFn: getAuthProviders,
  });

  return { providers, loading, error };
};
